export default __webpack_public_path__ + "static/media/twitter.09d9eef0.svg";